import { ValidatorWithErrors } from 'schemas/ajv-validators';

export const validateWithAjv = (validator: ValidatorWithErrors, value: unknown): string | null => {
  const validation = validator(value);
  if (!validation) {
    return validator.errors![0].message;
  }
  return null;
};
